<div>
  <div *ngIf="!displayConfirmation">
    <app-types-selection (selection)="onTypesSelectionChange($event)"></app-types-selection>

    <div *ngIf="typesSelected !== null">
      <app-medecin-form #MedecinFormMed [typesSelected]="typesSelected" *ngIf="typesSelected.situation.code === 'MED'">
      </app-medecin-form>

      <app-patient-form #PatientForm [typesSelected]="typesSelected" (indicatifs)="onIndicatifsChange($event)">
      </app-patient-form>

      <app-demandeur-form #DemandeurForm [typesSelected]="typesSelected"
        *ngIf="typesSelected.situation.code === 'INT' || (typesSelected.situation.code === 'FRA' && typesSelected.demande !== null)">
      </app-demandeur-form>

      <app-contact-form #ContactForm [typesSelected]="typesSelected" [indicatifs]="indicatifs"
        *ngIf="typesSelected.situation.code !== 'MED'">
      </app-contact-form>

      <app-medecin-form #MedecinFormInt [typesSelected]="typesSelected" [indicatifs]="indicatifs"
        *ngIf="typesSelected.situation.code === 'INT'">
      </app-medecin-form>

      <app-demande-form #DemandeForm *ngIf="!(typesSelected.situation.code === 'FRA' &&typesSelected.demande === null)"
        [typesSelected]="typesSelected">
      </app-demande-form>

      <app-rendez-vous-form #RendezvousForm
        *ngIf="typesSelected.situation.code === 'FRA' && typesSelected.demande === null">
      </app-rendez-vous-form>

      <app-historique-form #HistoriqueForm *ngIf="typesSelected.situation.code === 'INT'"></app-historique-form>

      <app-allergie-form #AllergieForm *ngIf="typesSelected.situation.code === 'INT'"></app-allergie-form>

      <mat-card>
        <mat-card-content class="d-flex flex-column col-md">
          <mat-checkbox [(ngModel)]="rgpd">
            <small><b>{{this.texteService.getTexte('LABEL_RGPD_CHECK')}}</b></small>
          </mat-checkbox>

          <h5>{{this.texteService.getTexte('LABEL_RGPD_TITLE')}}</h5>
          <span [innerHTML]="this.texteService.getTexte('LABEL_RGPD_TEXTE')"></span>

          <re-captcha (resolved)="recaptchaResolved($event)" [siteKey]="recaptchaKey" class="recaptcha">
          </re-captcha>

          <button mat-raised-button color="primary" (click)="onSubmit()" class="validation-button"
            [disabled]="!isValidForm() || !recaptchaValid || !rgpd">{{texteService.getTexte('BTN_VALIDATION')}}</button>

          <p *ngIf="displayError" class="error-message form-label" role="alert">{{texteService.getTexte('LABEL_VALIDATION_ERROR')}}</p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  <mat-card *ngIf="displayConfirmation && typesSelected !== null" class="d-flex flex-column align-items-center">
    <p class="primary-color form-label">{{texteService.getTexte('LABEL_VALIDATION_CONF')}}</p>
    <button mat-raised-button color="primary" class="after-validation-button"
      (click)="backToHome()">{{texteService.getTexte('BUTTON_HOME', 'Retour')}}</button>
  </mat-card>
</div>
